module.exports = __webpack_public_path__ + "img/banner-mobile.0b07b36c.jpg";